module.exports = __webpack_public_path__ + "media/images/logo-compleet-wit-ffde9b23c579ac513188d2c2e187aa90.svg";